import { render, staticRenderFns } from "./BoottomTab.vue?vue&type=template&id=ca0d7d88&scoped=true"
import script from "./BoottomTab.vue?vue&type=script&lang=js"
export * from "./BoottomTab.vue?vue&type=script&lang=js"
import style0 from "./BoottomTab.vue?vue&type=style&index=0&id=ca0d7d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0d7d88",
  null
  
)

export default component.exports